export const COLORS = [
	'#50ADF5', // azul
	'#FF7965', // coral
	'#FFCB45', // amarillo
	'#6877E5', // azul violeta
	'#6FB07F', // verde
	'#A47FFF', // morado
	'#FF9F40', // naranja
	'#4BC0C0', // turquesa
	'#F67070', // rojo suave
	'#9966FF', // violeta

	'#8DD776', // verde claro
	'#FFB6B9', // rosa
	'#36A2EB', // azul claro
	'#FF6384', // rosa fuerte
	'#FFCE56', // amarillo suave
	'#2EC4B6', // aqua
	'#E71D36', // rojo intenso
	'#9B5DE5', // púrpura
	'#F15BB5', // magenta
	'#00BBF9', // cyan

	'#00F5D4', // verde aqua
	'#FEE440', // amarillo vibrante
	'#F77F00', // naranja intenso
	'#D62828', // rojo oscuro
	'#3A86FF', // azul vivo
	'#8338EC', // violeta intenso
	'#FB5607', // naranja quemado
	'#06D6A0', // verde brillante
	'#EF476F', // rosa rojo
	'#118AB2', // azul petróleo

	'#073B4C', // azul oscuro
	'#FFD166', // amarillo crema
	'#CDB4DB', // lavanda
	'#FFC8DD', // rosa pastel
	'#BDE0FE', // azul pastel
	'#A3CEF1', // azul gris
	'#588157', // verde oliva
	'#BC6C25', // café
	'#6A0572', // morado oscuro
	'#3B1F2B' // vino
]

export default (title, subtitle, series = []) => {
	return {
		type: 'treemap',

		plot: {
			cursor: 'pointer'
		},
		options: {
			splitType: 'balanced',
			colorType: 'palette',
			palette: COLORS,
		},
		plotarea: {
			margin: '0 0 35 0'
		},

		series: series ? series : []
	}
}
